import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/cn";

const badgeVariants = cva(
  "inline-flex items-center rounded-md px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider transition-colors",
  {
    variants: {
      variant: {
        default:
          "bg-secondary text-secondary-foreground",
        primary:
          "bg-primary/15 text-primary border border-primary/30",
        success:
          "bg-success/15 text-success border border-success/30",
        warning:
          "bg-warning/15 text-warning border border-warning/30",
        danger:
          "bg-destructive/15 text-destructive border border-destructive/30",
        info:
          "bg-info/15 text-info border border-info/30",
        outline:
          "border border-border text-muted-foreground",
        muted:
          "bg-secondary text-muted-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
